/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar28 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar28", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 10.861328 14.306641 C 12.438328 14.306641 13.494141 15.151484 13.494141 16.396484 C 13.494141 17.177484 13.035156 17.871375 11.785156 18.984375 L 10.623047 20.052734 L 10.623047 20.146484 L 13.591797 20.146484 L 13.591797 21.542969 L 8.234375 21.542969 L 8.234375 20.347656 L 10.462891 18.251953 C 11.497891 17.294953 11.761719 16.939437 11.761719 16.523438 C 11.761719 16.005437 11.379828 15.658203 10.798828 15.658203 C 10.193828 15.658203 9.7734375 16.069391 9.7734375 16.650391 L 9.7734375 16.683594 L 8.1328125 16.683594 L 8.1328125 16.654297 C 8.1328125 15.253297 9.2263281 14.306641 10.861328 14.306641 z M 18.820312 14.306641 C 20.407312 14.306641 21.546875 15.122 21.546875 16.25 C 21.546875 16.992 21.019516 17.598531 20.228516 17.769531 L 20.228516 17.861328 C 21.190516 18.037328 21.833984 18.750438 21.833984 19.648438 C 21.832984 20.893437 20.616453 21.734375 18.814453 21.734375 C 17.017453 21.734375 15.8125 20.904062 15.8125 19.664062 C 15.8125 18.795063 16.442063 18.086328 17.414062 17.861328 L 17.414062 17.769531 C 16.623062 17.598531 16.095703 16.993 16.095703 16.25 C 16.095703 15.122 17.233312 14.306641 18.820312 14.306641 z M 18.820312 15.53125 C 18.258312 15.53125 17.857422 15.908016 17.857422 16.416016 C 17.857422 16.924016 18.264312 17.294922 18.820312 17.294922 C 19.377312 17.294922 19.777344 16.924016 19.777344 16.416016 C 19.777344 15.908016 19.377313 15.53125 18.820312 15.53125 z M 18.820312 18.515625 C 18.151312 18.515625 17.6875 18.920094 17.6875 19.496094 C 17.6875 20.077094 18.151312 20.474609 18.820312 20.474609 C 19.489313 20.474609 19.947266 20.077094 19.947266 19.496094 C 19.947266 18.920094 19.484313 18.515625 18.820312 18.515625 z" />
      </svg>
    );
  }
}

IconCalendar28.defaultProps = {
  className: null
};

IconCalendar28.propTypes = {
  className: PropTypes.string
};

export default IconCalendar28;
